import { FlexCol, FlexRow } from '@/components/common/Flex';
import { Box, Circle } from '@chakra-ui/react';
import { FC } from 'react';
import { Text } from '../common/Typography';

export interface VerticalProgressTrailStepConfig {
    title: string;
    description?: string;
}

export interface VerticalProgressTrailProps {
    stepConfigs: VerticalProgressTrailStepConfig[];
    numberOfStepsCompleted: number;
}

const VerticalProgressTrail: FC<VerticalProgressTrailProps> = ({
    stepConfigs,
    numberOfStepsCompleted,
}) => {
    return (
        <FlexCol>
            {stepConfigs.map(({ title, description }, i) => {
                return (
                    <VerticalProgressTrailStep
                        key={title + i}
                        title={title}
                        description={description}
                        isCompleted={i + 1 <= numberOfStepsCompleted}
                        isNextCompleted={i + 2 <= numberOfStepsCompleted}
                        isLast={i === stepConfigs.length - 1}
                    />
                );
            })}
        </FlexCol>
    );
};

const COMPONENT_WIDTH = 10;
const IN_PROGRESS_COLOR = 'gray.300';
const COMPLETED_COLOR = 'blue.500';
const CIRCLE_VERTICAL_OFFSET = 4;
const CIRCLE_WIDTH = '10px';
// If CIRCLE_WIDTH is even, LINE_WIDTH should be even
// If CIRCLE_WIDTH is odd, LINE_WIDTH should be odd
const LINE_WIDTH = '2px';

const VerticalProgressTrailStep: FC<{
    title: string;
    description?: string;
    isCompleted: boolean;
    isNextCompleted: boolean;
    isLast: boolean;
}> = ({ title, description, isLast, isCompleted, isNextCompleted }) => {
    return (
        <FlexRow>
            <FlexRow
                justifyContent="center"
                minW={COMPONENT_WIDTH}
                maxW={COMPONENT_WIDTH}
            >
                <Circle
                    position="absolute"
                    bg={isCompleted ? COMPLETED_COLOR : IN_PROGRESS_COLOR}
                    size={CIRCLE_WIDTH}
                    mt={CIRCLE_VERTICAL_OFFSET}
                ></Circle>
                {!isLast && (
                    <Box
                        bg={
                            isNextCompleted
                                ? COMPLETED_COLOR
                                : IN_PROGRESS_COLOR
                        }
                        width={LINE_WIDTH}
                        height="full"
                        mt={CIRCLE_VERTICAL_OFFSET}
                    ></Box>
                )}
            </FlexRow>
            <FlexCol py={2}>
                <Text>{title}</Text>
                <Text color="textMuted" fontSize="sm">
                    {description}
                </Text>
            </FlexCol>
        </FlexRow>
    );
};

export default VerticalProgressTrail;
